import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import type { Tomo } from '../data/packContents';
export const VolumeCard = ({
  tomo
}: {
  tomo: Tomo;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = `volume-${tomo.n}-content`;
  return <article className="glass-panel rounded-sm p-4 md:p-5" data-id="element-258" data-mp="y4gr5hn26ljh">
      <div className="flex items-start gap-4" data-id="element-259" data-mp="1ut4vxc9rkcay">
        <img src={tomo.cover} alt={`Volume ${tomo.n}: ${tomo.title}`} loading="lazy" className="w-14 md:w-16 shrink-0 aspect-[4/5] object-cover border border-brand-gold/40" data-id="element-260" data-mp="1uswh3eu2ywx4" />

        <div className="min-w-0 flex-1" data-id="element-261" data-mp="1l2thuwwd8mqc">
          <span className="block font-seal text-[11px] uppercase tracking-seal text-brand-goldDark mb-1" data-id="element-262" data-mp="1l1iayo7miyv0">
            Volume {tomo.n}
          </span>
          <h3 className="font-display font-bold text-lg md:text-xl leading-tight text-brand-burgundy" data-id="element-263" data-mp="2dk5rdqbodppr">
            {tomo.title}
          </h3>
          <p className="mt-1 text-[15px] leading-snug text-brand-muted" data-id="element-264" data-mp="28rw6iopf3fuc">
            {tomo.subtitle}
          </p>
        </div>

        <button type="button" aria-expanded={isOpen} aria-controls={panelId} aria-label={isOpen ? `Nascondi il contenuto del Volume ${tomo.n}` : `Mostra il contenuto del Volume ${tomo.n}`} onClick={() => setIsOpen(v => !v)} className="shrink-0 mt-0.5 p-1.5 border border-brand-gold/40 rounded-sm text-brand-goldDark hover:bg-brand-surfaceLight/50 transition-colors duration-150 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold" data-id="element-265" data-mp="3cb3pwao5efzs">
          <Plus className={`w-4 h-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-266" data-mp="2tldqfa9fx61j" />
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-267" data-mp="2jmg1w7c0lcij">
        {isOpen && <motion.div id={panelId} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-268" data-mp="2jn7lskw91lsz">
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 text-[15px] text-brand-text" data-id="element-269" data-mp="gf7ciihxry5p">
              {tomo.features.map(f => <li key={f} className="flex items-start gap-2" data-id="element-270" data-mp="6fgei6u6310v">
                  <span aria-hidden="true" className="mt-1.5 w-1 h-1 rotate-45 bg-brand-gold shrink-0" data-id="element-271" data-mp="6fzv9k82zjdb" />
                  <span data-id="element-272" data-mp="2g7nvaufbj9j">{f}</span>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </article>;
};